// The organisation's plan, across the top of every screen (owner, 1 Oct
// 2026 — doc/5.10.2026.md):
//   - from 15 days before the end date, to the tenant ADMIN: "Your plan ends
//     on <date>. Contact Mitra One Care to renew." (they also get one e-mail);
//   - after the end, when the Super Admin chose "Message only", to EVERYONE
//     at the organisation: "Your plan ended on <date>. Contact Mitra One Care
//     to renew." — the app keeps working.
// With "Lock" nobody gets this far: sign-in refuses them. A renewal removes
// the banner at once (the state is re-read with the features).
import { useTranslation } from 'react-i18next';
import { CalendarClock } from 'lucide-react';
import useTenantFeatures from '../../hooks/useTenantFeatures';

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const day = (d) => {
    const [y, m, dd] = String(d || '').slice(0, 10).split('-').map(Number);
    return y && m && dd ? `${dd} ${MONTHS[m - 1]} ${y}` : '';
};

export default function TenantPlanBanner() {
    const { t } = useTranslation();
    const { billing } = useTenantFeatures();
    const role = localStorage.getItem('Role') || '';
    const isSuperAdmin = localStorage.getItem('isSuperAdmin') === 'true';
    if (!billing || isSuperAdmin || role === 'patient') return null;

    let text = null;
    if (billing.kind === 'ended' && billing.action === 'message' && billing.endedOn) {
        text = t('tenantSubscription.banner_ended', 'Your plan ended on {{date}}. Contact Mitra One Care to renew.', { date: day(billing.endedOn) });
    } else if (billing.kind === 'active' && billing.endingSoon && role === 'admin' && billing.endsOn) {
        text = t('tenantSubscription.banner_ending', 'Your plan ends on {{date}}. Contact Mitra One Care to renew.', { date: day(billing.endsOn) });
    }
    if (!text) return null;

    return (
        <div data-testid="tenant-plan-banner" role="status"
            className="flex items-center gap-2 bg-[#D7A05C]/15 border-b border-[#D7A05C]/40 px-4 py-2 text-[13px] font-semibold text-[#8a5a1a]">
            <CalendarClock className="w-4 h-4 flex-shrink-0" />
            <span>{text}</span>
        </div>
    );
}
